// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"styles_skeletonCard__smwxB","skeletonImage":"styles_skeletonImage__iPjro"};